export default __webpack_public_path__ + "static/media/masiau2.76c9cb98.jpg";